import { TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import MyTab from "@/components/atoms/tab/MyTab";
import ComingSoonFeaturedText from "@/components/molecules/company/detail/ComingSoonFeaturedText";
import CompanyDetailFinancials from "@/components/molecules/company/detail/overview/tabs/CompanyDetailFinancials";
import CompanyDetailFundings from "@/components/molecules/company/detail/overview/tabs/CompanyDetailFundings";
import CompanyDetailNews from "@/components/molecules/company/detail/overview/tabs/CompanyDetailNews";
import CompanyDetailOwnerships from "@/components/molecules/company/detail/overview/tabs/CompanyDetailOwnerships";

type Props = {
  id: string;
};

const CompanyDetailOverviewInsightTabs = ({ id }: Props) => {
  const { t } = useTranslation();

  return (
    <TabGroup>
      <div className={"sticky top-[37px] z-10 mt-5"}>
        <h2 className={"bg-white pb-3 pt-5 font-semibold text-primary"}>
          {t("company.detail.overview.insights.more")}
        </h2>

        <TabList className={"flex w-full flex-1 bg-white"}>
          <MyTab label={t("company.detail.tabs.overview.financials")} />
          <MyTab label={t("company.detail.tabs.overview.news")} />
          <MyTab label={t("company.detail.tabs.overview.funding")} />
          <MyTab label={t("company.detail.tabs.overview.departments")} />
          <MyTab label={t("company.detail.tabs.overview.ownerships")} />
        </TabList>
      </div>

      <TabPanels>
        <TabPanel>
          <CompanyDetailFinancials id={id} />
        </TabPanel>
        <TabPanel>
          <CompanyDetailNews id={id} />
        </TabPanel>
        <TabPanel>
          <CompanyDetailFundings id={id} />
        </TabPanel>
        <TabPanel>
          <ComingSoonFeaturedText featureName={"departments"} />
        </TabPanel>
        <TabPanel>
          <CompanyDetailOwnerships id={id} />
        </TabPanel>
      </TabPanels>
    </TabGroup>
  );
};

export default CompanyDetailOverviewInsightTabs;
